import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
/**
 * Static navigation menu definition.
 *
 * `ngOnInit` populates `model` with three top-level groups: Робота (Work), Товари
 * (Products), and Контрагенти (Counterparties), each with their respective route links.
 */
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    /** Builds the three-group navigation model (Work, Products, Counterparties). */
    ngOnInit() {
        this.model = [
          {
            label: 'Работа',
            icon: 'pi pi-home',
            items: [
              {
                label: 'Обзор',
                icon: 'pi pi-fw pi-chart-bar',
                routerLink: ['/home']
              },
              {
                label: 'Документы',
                icon: 'pi pi-fw pi-book',
                routerLink: ['/documents']
              },
              {
                label: 'Сделки',
                icon: 'pi pi-fw pi-user-edit',
                routerLink: ['/sales-leads']
              },
              {
                label: 'Валюты и курсы',
                icon: 'pi pi-fw pi-dollar',
                routerLink: ['/currency-rates']
              },
            ]
          },
          {
            label: 'Товары',
            icon: 'pi pi-box',

            items: [
              {
                label: 'Каталог',
                icon: 'pi pi-fw pi-folder',
                routerLink: ['/products'],
              },
              {
                label: 'Оборотная ведомость',
                icon: 'pi pi-fw pi-list',
                routerLink: ['/show-itemturnoverreport/0']
              },
              {
                label: 'Создать прайс-лист',
                icon: 'pi pi-fw pi-file-export',
                routerLink: ['/create-pricelist']
              },
            ]
          },
          {
            label: 'Контрагенты',
            icon: 'pi pi-id-card',
            items: [
              {
                label: 'Компании',
                icon: 'pi pi-fw pi-users',
                routerLink: ['/clients']
              },
              {
                label: 'Люди',
                icon: 'pi pi-fw pi-user',
                routerLink: ['/persons']
              },
            ]
          }
      ];
    }
}
